import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import axios from 'axios';

const AnalyticsTestData = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const createTestData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token') || 'mock-token';
      const baseURL = process.env.REACT_APP_BACKEND_URL;

      // Create some test walk activities
      const activities = [
        {
          activity_type: "walk_completed",
          start_time: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days ago
          end_time: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000 + 45 * 60 * 1000).toISOString(),
          duration_minutes: 45,
          distance_meters: 3200,
          elevation_gain_meters: 50,
          location: "Griffith Park Observatory",
          neighborhood: "Los Feliz",
          city: "Los Angeles",
          description: "Morning hike to the observatory",
          weather: "Clear",
          companions: ["Sarah"],
          photos_taken: 5,
          completed: true,
          manually_logged: false
        },
        {
          activity_type: "walk_completed",
          start_time: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
          end_time: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000 + 30 * 60 * 1000).toISOString(),
          duration_minutes: 30,
          distance_meters: 2100,
          elevation_gain_meters: 20,
          location: "Venice Beach Boardwalk",
          neighborhood: "Venice",
          city: "Los Angeles",
          description: "Sunset walk along the beach",
          weather: "Sunny",
          companions: [],
          photos_taken: 8,
          completed: true,
          manually_logged: false
        },
        {
          activity_type: "walk_completed",
          start_time: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
          end_time: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000 + 60 * 60 * 1000).toISOString(),
          duration_minutes: 60,
          distance_meters: 4500,
          elevation_gain_meters: 100,
          location: "Hollywood Hills Trail",
          neighborhood: "Hollywood",
          city: "Los Angeles",
          description: "Weekend adventure hike",
          weather: "Partly Cloudy",
          companions: ["Mike", "Lisa"],
          photos_taken: 12,
          completed: true,
          manually_logged: false
        },
        {
          activity_type: "walk_completed",
          start_time: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
          end_time: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000 + 25 * 60 * 1000).toISOString(),
          duration_minutes: 25,
          distance_meters: 1800,
          elevation_gain_meters: 10,
          location: "Silver Lake Reservoir",
          neighborhood: "Silver Lake",
          city: "Los Angeles",
          description: "Quick morning loop",
          weather: "Clear",
          companions: [],
          photos_taken: 3,
          completed: true,
          manually_logged: false
        },
        {
          activity_type: "manual_log",
          start_time: new Date().toISOString(),
          duration_minutes: 40,
          distance_meters: 2800,
          location: "Downtown LA Arts District",
          neighborhood: "Downtown",
          city: "Los Angeles",
          description: "Lunch break exploration",
          weather: "Sunny",
          companions: ["Alex"],
          photos_taken: 6,
          completed: true,
          manually_logged: true
        }
      ];

      // Post each activity
      for (const activity of activities) {
        await axios.post(`${baseURL}/api/analytics/activities`, activity, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
      }

      setMessage('✅ Test data created successfully! You can now view your analytics dashboard.');
    } catch (error) {
      console.error('Error creating test data:', error);
      setMessage('❌ Error creating test data. Make sure you\'re signed in as a premium user.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="p-6 m-4">
      <h3 className="text-lg font-semibold mb-4">Analytics Test Data</h3>
      <p className="text-gray-600 mb-4">
        Create sample walk activities to test the analytics dashboard functionality.
      </p>
      <Button 
        onClick={createTestData} 
        disabled={loading}
        className="mb-4"
      >
        {loading ? 'Creating Test Data...' : 'Create Test Data'}
      </Button>
      {message && (
        <div className="mt-4 p-3 rounded-lg bg-gray-50">
          <p className="text-sm">{message}</p>
        </div>
      )}
    </Card>
  );
};

export default AnalyticsTestData;